module.exports = __webpack_public_path__ + "static/media/page_1_side_left.4d64f5d8.png";